import { z } from "zod";

import i18n from "@/i18n";

export const referralProgramSchema = z.object({
	isActive: z.boolean(),
	pointsPerReferral: z.coerce
		.number({ invalid_type_error: i18n.t("referral.minPoints") })
		.int()
		.min(1, i18n.t("referral.minPoints")),
	shareText: z.string(),
});

export type ReferralProgramValues = z.infer<typeof referralProgramSchema>;

export const rewardDraftSchema = z.object({
	id: z.string().optional(),
	reward: z.string().trim().min(1, i18n.t("referral.rewardRequired")),
	pointsCost: z.coerce
		.number({ invalid_type_error: i18n.t("referral.minPoints") })
		.int()
		.min(1, i18n.t("referral.minPoints")),
	isActive: z.boolean(),
});

export type RewardDraft = z.infer<typeof rewardDraftSchema>;

export function emptyRewardDraft(): RewardDraft {
	return { reward: "", pointsCost: 1, isActive: true };
}
